<template>
    <div>
        <v-autocomplete
                v-model="selectedUser"
                :label="label"
                item-text="firstName"
                item-value="id"
                :items="users"
                type="select"
                return-object
                @change="emitSelected"
        >

            <template v-slot:selection="data">
                <template v-if="data.item.firstName">

                    <v-list-item-avatar >
                        <img :src="data.item.avatar">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{data.item.firstName}} {{data.item.lastName}}</v-list-item-title>
                    </v-list-item-content>
                </template>
            </template>

            <template v-slot:item="data">
                <template v-if="data.item.firstName">

                    <v-list-item-avatar >
                        <img :src="data.item.avatar">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{data.item.firstName}} {{data.item.lastName}}</v-list-item-title>
                    </v-list-item-content>
                </template>
            </template>

        </v-autocomplete>
    </div>
</template>

<script>
    import USERS_LIST from "../../graphql/Users/List.gql";

    export default {
        props: {
            userId: {
                type: Number,
                default: 0
            },
            label: {
                type: String,
                default: 'User'
            }
        },
        data() {
            return {
                selectedUser: {}
            }
        },
        apollo: {
            users: {
                query: USERS_LIST,
                update: data => data.users
            },
        },
        methods: {
            emitSelected(item) {
                this.$emit('selected', item)
            }
        },
    }
</script>

<style scoped>

</style>